/** Header switch for the 15-minute voice: off until it is switched on; then the browser says the time at
 * every 15-minute close of the market (09:30 ... 15:30 IST, trading days). Switching it on is the click
 * the browser needs before it lets a page speak, so it says "Voice on" once. */

import { useState, type ReactElement } from "react";
import { say, storeVoice, useCandleVoice, voiceStored } from "@/hooks/useCandleVoice";

export function CandleVoiceToggle(): ReactElement {
  const [on, setOn] = useState<boolean>(voiceStored);
  useCandleVoice(on);
  const toggle = (): void => {
    const next = !on;
    setOn(next);
    storeVoice(next);
    if (next) say("Voice on");
  };
  return (
    <button
      type="button"
      className="btn btn-secondary text-sm"
      onClick={toggle}
      aria-pressed={on}
      title="Say the time at every 15-minute candle close, 09:30 to 15:30 IST on trading days"
    >
      <i className={`ti ${on ? "ti-microphone" : "ti-microphone-off"} text-base`} />
      {on ? "15-min voice on" : "15-min voice off"}
    </button>
  );
}
